export abstract class AbstractApi {
  protected async get<T>(endpoint: string, apiName: string): Promise<T> {
    return this.fetchJson(endpoint, apiName, 'GET');
  }

  async post(endpoint: string, apiName: string, bodyAsJson: object) {
    return this.send(endpoint, 'POST', apiName, bodyAsJson);
  }

  async delete(endpoint: string, apiName: string, bodyAsJson: object) {
    return this.send(endpoint, 'DELETE', apiName, bodyAsJson);
  }

  protected async postJson<T>(endpoint: string, apiName: string, bodyAsJson: unknown): Promise<T> {
    return this.fetchJson(endpoint, apiName, 'POST', bodyAsJson);
  }

  protected async deleteJson<T>(endpoint: string, apiName: string, bodyAsJson: unknown): Promise<T> {
    return this.fetchJson(endpoint, apiName, 'DELETE', bodyAsJson);
  }

  private async fetchJson<T>(endpoint: string, apiName: string, method: string, body?: unknown): Promise<T> {
    const response = await fetch(endpoint, this.buildFetchOptions(method, body));

    if (response.status >= 400) {
      throw new Error(`${apiName} API call failed: ${await response.text()}`);
    }

    return response.json();
  }

  private async send(endpoint: string, method: 'POST' | 'DELETE' | 'PUT', apiName: string, bodyAsJson: object) {
    try {
      const response = await fetch(endpoint, this.buildFetchOptions(method, bodyAsJson));
      return response.ok;
    } catch (error) {
      console.error(`${apiName} Api call failed:`, error);
      return false;
    }
  }

  private buildFetchOptions(method: string, body?: unknown): RequestInit {
    const options: RequestInit = {
      method,
      mode: 'same-origin',
      credentials: 'same-origin',
      cache: 'no-cache',
      headers: {
        'Content-Type': 'application/json',
      },
      ...(body === undefined ? {} : { body: JSON.stringify(body) }),
    };

    if (typeof AbortSignal !== 'undefined' && typeof AbortSignal.timeout === 'function') {
      options.signal = AbortSignal.timeout(5000);
    }

    return options;
  }
}
